import { Http } from 'services/http'

async function validatePostalCode(postalCode) {
  const body = { new_postal_code: postalCode }

  const path = '/postal-codes/actions/change-pc/'
  const options = {
    shouldCatchErrors: false,
    body: JSON.stringify(body),
  }

  return Http.put(path, options)
}

export const DeliveryAreaClient = {
  validatePostalCode,
}
